
import { Component, Vue, Prop } from 'vue-property-decorator';
import { autoColor } from '@/utils/tools';
@Component({
  directives: {
    autoColor: {
      bind(el) {
        el.style.color = autoColor(el.innerText);
      },
      componentUpdated(el) {
        el.style.color = autoColor(el.innerText);
      },
    },
  },
})
export default class CommonRankNumber extends Vue {
  @Prop() private num!: number | string;
  @Prop() private size!: string;
  @Prop() private isNeedArrow!: boolean;
  @Prop() private isActive!: boolean;
  @Prop() private type!: string;
  get formateNum() {
    let { num } = this;
    if (typeof num === 'string') {
      num = num.replace('%', '');
    }
    num = Number(parseFloat(`${num}`).toFixed(2));
    if (isNaN(num)) {
      return '--.--';
    }
    if (this.type === 'rate') {
      return `${num > 0 ? '+' : ''}${num.toFixed(2)}%`;
    } else {
      return num;
    }
  }
  handleClick() {
    this.$emit('handleClick');
  }
}
